// export const API_BASE_URL = "http://172.24.109.129/";
// export const PRODUCT_BASE_URL = "http://localhost:3000/";
export const API_BASE_URL = "https://ethnustech.com:8843/";
export const PRODUCT_BASE_URL = "https://asset-managment-asset.firebaseapp.com/";

export let isLoggedIn = () => {
	return localStorage.getItem("user");
}


// WEBPACK FOOTER //
// ./src/config/constants.js